<template>
  <div class="animated fadeIn">
    <CalloutChartExample/>
    <b-row>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <h4 class="mb-0">1</h4>
            <p>Usuarios</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="pb-0">
            <h4 class="mb-0">10</h4>
            <p>Productos</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="pb-0">
            <h4 class="mb-0">10</h4>
            <p>Categoria</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-warning">
          <b-card-body class="pb-0">
            <h4 class="mb-0">20</h4>
            <p>Pedidos</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-danger">
          <b-card-body class="pb-0">
            <h4 class="mb-0">10</h4>
            <p>Carnets</p>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import CalloutChartExample from '@/views/dashboard/CalloutChartExample.vue'
export default {
  name: 'Dashboard',
  components: {
    CalloutChartExample
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/Dashboard.vue